import React, { useState, useContext } from "react";
import { Form, Input, Button } from "antd";
import { useLocalStorage } from "../hooks";
import { UserContext } from "../context/UserContext";
import { editProfile } from "../utils/api";
import LoadingIcon from "./LoadingIcon";

const ProfileModalContent = ({ setOpen }) => {
  const { userData } = useContext(UserContext);
  const [isLoading, setIsLoading] = useState(false);

  const onFinish = async (values) => {
    console.log("Success:", values);
    setIsLoading(true);
    const res = await editProfile({ values });
    setIsLoading(false);
    setOpen(false);
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <div className="flex justify-center ">
      {!isLoading ? (
        <Form
          id="myForm"
          layout="vertical"
          className="max-w-[80%]"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <div className="flex items-center justify-around">
            <Form.Item
              className="mr-2"
              name="first_name"
              label="First Name"
              initialValue={`${userData?.first_name}`}
              rules={[
                {
                  required: true,
                  message: "Please input your name!",
                },
              ]}
            >
              <Input placeholder="First Name" />
            </Form.Item>
            <Form.Item
              name="last_name"
              label="Last Name"
              initialValue={`${userData?.last_name}`}
            >
              <Input placeholder="Last Name" />
            </Form.Item>
          </div>

          <Form.Item
            name="email"
            label="Email"
            initialValue={`${userData?.email}`}
            rules={[
              {
                type: "email",
                required: true,
                message: "Please input your email!",
              },
            ]}
          >
            <Input placeholder="Email" disabled />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </Form.Item>
        </Form>
      ) : (
        <LoadingIcon height="200px" classname="absolute h-full" />
      )}
    </div>
  );
};

export default ProfileModalContent;
